export default "__VITE_ASSET__nycS5fl8__"